




















import Vue from "vue";
import { mapGetters } from "vuex";
import vIcon from "../v-components/v-icon.vue";

export default Vue.extend({
  components: { vIcon },
  name: "Notification",
  data: () => {
    return {
      currentComponent: null as null
    };
  },
  computed: {
    ...mapGetters(["GET_NOTIFICATION_STATUS"])
  },
  watch: {
    GET_NOTIFICATION_STATUS(state): void {
      state.status
        ? (this.loadComponent(),
          state.autoFocus ? this.focusToElement() : null,
          state.autoDismiss
            ? setTimeout(this.handleDismissNotification, 20000)
            : null)
        : null;
    }
  },
  methods: {
    handleDismissNotification(): void {
      this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
        status: false,
        component: ""
      });
    },

    focusToElement(): void {
      Vue.nextTick(() => {
        ((this.$refs.close as
          | Vue
          | Element
          | Vue[]
          | Element[]) as HTMLElement).focus();
      });
    },

    loadComponent(): void {
      const component: string = this.GET_NOTIFICATION_STATUS.component;
      import(
        `@/components/notifications/Notification${component
          .charAt(0)
          .toUpperCase()}${component.slice(1)}.vue`
      )
        .then(res => (this.currentComponent = res.default))
        .catch(error => console.log(error));
    }
  }
});
